import { render, staticRenderFns } from "./couponItemT.vue?vue&type=template&id=5811774a&scoped=true&"
import script from "./couponItemT.vue?vue&type=script&lang=js&"
export * from "./couponItemT.vue?vue&type=script&lang=js&"
import style0 from "./couponItemT.vue?vue&type=style&index=0&id=5811774a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5811774a",
  null
  
)

export default component.exports